import { ShortcutTypeDirectory } from 'src/app/samwebDescription/samweb/shortcuts/shortcutTypeDirectory';

export class ChangeAutoSearchColumn {
   public static readonly type = '[DirectorySettings] Change auto search column';

   constructor(public brickInstanceId, public searchingColumnKey: string) {}
}
export class ChangeAutomaticFilterOnSkillOrganisationAssociations {
   public static readonly type = '[DirectorySettings] Change automatic filter on skill organisation associations';

   constructor(public brickInstanceId, public isFilterEnabled: boolean) {}
}

export class ChangeAutomaticRestrictForIncomingCaller {
   public static readonly type = '[DirectorySettings] Change automatic restrict for incoming caller';

   constructor(public brickInstanceId, public isFilterEnabled: boolean) {}
}

export class ChangeMinLengthToStartFiltering {
   public static readonly type = '[DirectorySettings] Change min length to start filtering';

   constructor(public brickInstanceId, public minLengthToStartFiltering: number) {}
}

export class ChangeRetainFilterOnCallFinish {
   public static readonly type = '[DirectorySettings] Change retain filter on call finish';

   constructor(public brickInstanceId, public retainFilterOnCallFinish: boolean) {}
}

export class ChangeStartNewCallOnDoubleClick {
   public static readonly type = '[DirectorySettings] Change start new call on double click';

   constructor(public brickInstanceId, public startNewCallOnDoubleClick: boolean) {}
}

export class ChangeClearSearchBoxOnIncomingCall {
   public static readonly type = '[DirectorySettings] Change clear search box on incoming call';

   constructor(public brickInstanceId, public clearSearchBoxOnIncomingCall: boolean) {}
}

export class ChangeDirectorySearchableColumns {
   public static readonly type = '[DirectorySettings] Change directory searchable columns';

   constructor(public brickInstanceId, public searchableColumnKeys: string[]) {}
}

export class ChangeDirectorySearchablePhoneticColumns {
   public static readonly type = '[DirectorySettings] Change directory searchable phonetic columns';

   constructor(public brickInstanceId, public searchableColumnKeys: string[]) {}
}

export class ChangeDirectoryCallableColumns {
   public static readonly type = '[DirectorySettings] Change directory callable columns';

   constructor(public brickInstanceId, public callableColumnKeys: string[]) {}
}

export class ChangeDirectoryDefaultCallColumn {
   public static readonly type = '[DirectorySettings] Change directory default call column';

   constructor(public brickInstanceId, public defaultCallColumnKey: string) {}
}

export class ChangeDirectoryDefaultSortColumn {
   public static readonly type = '[DirectorySettings] Change directory default sort column';

   constructor(public brickInstanceId, public defaultSortColumnKey: string) {}
}

export class ChangeDefaultDirectoryId {
   public static readonly type = '[DirectorySettings] Change default directory id';

   constructor(public brickInstanceId, public defaultDirectoryId: number) {}
}

export class ChangedHotkeyCombo {
   public static readonly type = '[DirectorySettings] Change hotkey kombo';

   constructor(public brickInstanceId, public shortcutType: ShortcutTypeDirectory, public combo: string) {}
}

export class ChangeSchedulerSelectedView {
   public static readonly type = '[DirectorySettings] Change scheduler selected view';

   constructor(public brickInstanceId, public viewId: number) {}
}

export class ChangeSchedulerShowBusinessHours {
   public static readonly type = '[DirectorySettings] Change scheduler show business hours';

   constructor(public brickInstanceId, public checked: boolean) {}
}
